import { useI18n } from "../../i18n/I18nProvider";

const ROWS = [0, 1, 2, 3];

/** Loading state: ice bars shaped like roster rows, announced once as loading. */
export function RosterSkeleton() {
  const { t } = useI18n();
  return (
    <div aria-busy="true" className="divide-y divide-hairline border-y border-hairline">
      <p className="sr-only">{t("app.loading")}</p>
      {ROWS.map((row) => (
        <div
          key={row}
          aria-hidden="true"
          className="grid grid-cols-[3rem_minmax(0,1fr)] gap-3 py-4 sm:grid-cols-[3.5rem_3rem_minmax(0,1fr)] sm:gap-4"
        >
          <span className="h-8 w-10 rounded bg-ice-2 motion-safe:animate-pulse" />
          <span className="hidden size-12 rounded-[10px] bg-ice-2 sm:block" />
          <span className="flex flex-col gap-2">
            <span className="h-4 w-40 max-w-full rounded bg-ice-2" />
            <span className="h-3 w-56 max-w-full rounded bg-ice-2" />
          </span>
        </div>
      ))}
    </div>
  );
}
